import { useRef } from "react";

import { useFrame } from "@react-three/fiber";
import useGame from '@stores/useGame';

export function Lights() {
    const lightRef = useRef();
    const blockSize = useGame((state) => state.blockSize);

    /**
     * Update the light each frame to follow the ball
     */
    useFrame((state) => {
        /**
         * Camera position Z + 1 to make the distance between camera and the ball
         * Camera position Z - 4 because the Z position of each block is multiplied by 4, 
         * so the light will follow the ball as it decreases by 4.
         * 
         * Needs update the matrix of the target light to work.
         * 
         * Example: First block => z: 0, Second block => z: 4, Third block => z: 8 ... etc.
         */
        lightRef.current.position.z = state.camera.position.z + 1 - blockSize;
        lightRef.current.target.z = state.camera.position.z - blockSize;
        lightRef.current.target.updateMatrixWorld();
    })

    return (
        <>
            <directionalLight
                ref={lightRef}
                castShadow
                position={[4, 6, 1]}
                intensity={1.5}
                shadow-mapSize={[4096, 4096]}
                shadow-camera-near={0.01}
                shadow-camera-far={20}
                shadow-camera-top={20}
                shadow-camera-right={100}
                shadow-camera-bottom={-10}
                shadow-camera-left={-10}
            />

            <ambientLight intensity={1} />
        </>
    )
}